import {html, LitElement} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {modalFlyoutStyles} from "@/components/modal-flyout/modal-flyout.styles";
import {SbkLink} from "@/components/link/link.ts";
import {modalStyle} from "@/components/modal/modal.styles.ts";
import "./modal-flyout.scss"

@customElement('sbk-modal-flyout')
export class SbkModalFlyout extends LitElement {

    @property()
    heading = '';

    @state()
    expanded = false;

    static get styles() {
        return [modalStyle,modalFlyoutStyles];
    }

    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('keydown', this._handleKeyDown);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('keydown', this._handleKeyDown);
    }

    private _handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape' && this.expanded) {
            this._handleClick(event)
        }
    };

    render() {
        return html`
            <div class="wrapper">
                <slot name="triggerElement" @click=${this._handleClick}></slot>
                <div class="modal-flyout${this.expanded ? ' expanded' : ''}">
                    <div class="modal-flyout__header">
                        ${this.heading ? html`<h3 tabindex="0">${this.heading}</h3>` : ''}
                        <sbk-round-button size="medium" variant="round" icon="close" class="close-button"
                                          @click=${this._handleClick}></sbk-round-button>
                    </div>
                    <div class="modal-flyout__content">
                        <slot></slot>
                    </div>
                    <div class="modal-flyout__footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
            <div class="backdrop${this.expanded ? ' expanded' : ''}"
                 @click=${this._handleClick}></div>
        `;
    }

    _handleClick(event: Event) {
        event.preventDefault()
        this.expanded = !this.expanded
        if (this.expanded) {
            document.body.classList.add('no-scroll')
        } else {
            document.body.classList.remove('no-scroll')
        }
        this._changeTriggerElement()
        const triggeredFlyout = new CustomEvent('triggeredModalFlyout', {
            bubbles: true,
            composed: true,
            detail: {
                id: this.id,
                expanded: this.expanded
            }
        })
        this.dispatchEvent(triggeredFlyout)
    }

    _changeTriggerElement() {
        const link = this.querySelector('sbk-link[slot="triggerElement"]') as SbkLink
        if (link) {
            link.setAttribute('aria-expanded', String(this.expanded))
            link.isSelected = this.expanded
        }
    }
}
